import { AlreadyTranslatedText } from '@execonline-inc/translations';
import { observer } from 'mobx-react';
import LearningCollectionEditStore from '../../../../../../../Edit/Store';
import Modal from '../../../../../../../Modal';
import { SectionContext } from '../../../../../../../Types';
import Header from '../../../../Header';
import Store from '../../../../Store';
import { ExperienceResource } from '../../../../Types';
import Warning from './Warning';
import CardBanner from '../../../../ModalBody/Heading/CardBanner';

export interface Props {
  store: Store;
  learningDesignName: AlreadyTranslatedText;
  learningCollectionStore: LearningCollectionEditStore;
  context: SectionContext;
  close: () => void;
  resource: ExperienceResource;
}

function AddLearningJourney({
  store,
  learningDesignName,
  learningCollectionStore,
  context,
  resource,
  close,
}: Props) {
  return (
    <Modal
      close={close}
      title={<Header />}
      modalWidth="h-4/5 w-4/5 min-h-[400px] max-h-[90vh] overflow-y-auto"
      customBackgroundCssClasses="bg-teal-100 opacity-60"
    >
      <div>
        <CardBanner
          context={context}
          learningCollectionStore={learningCollectionStore}
          learningDesignName={learningDesignName}
        />
        <Warning
          store={store}
          learningDesignName={learningDesignName}
          learningCollectionStore={learningCollectionStore}
          context={context}
          close={close}
          resource={resource}
        />
      </div>
    </Modal>
  );
}

export default observer(AddLearningJourney);
